package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.TooltipDemo

@Page
@Composable
fun TooltipPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/tooltip.md", mapOf("title" to listOf("Tooltip"), "description" to listOf("A popup that displays information related to an element when the element receives keyboard focus or the mouse hovers over it."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/tooltip"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/tooltip#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import lucide_react.Plus
import react.FC
import react.Props
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import shadcn.ui.components.*
import web.cssom.ClassName

val TooltipDemo = FC<Props> {
    TooltipProvider {
        Tooltip {
            TooltipTrigger {
                asChild = true
                Button {
                    variant = "outline"
                    className = ClassName("w-10 rounded-full p-0")
                    Plus { className = ClassName("h-4 w-4") }
                    span {
                        className = ClassName("sr-only")
                        +"Add"
                    }
                }
            }
            TooltipContent {
                p {
                    +"Add to library"
                }
            }
        }
    }
}"""){ 
 TooltipDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Tooltip
import shadcn.ui.components.TooltipContent
import shadcn.ui.components.TooltipProvider
import shadcn.ui.components.TooltipTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""TooltipProvider {
    Tooltip {
        TooltipTrigger { +"Hover" }
        TooltipContent {
            p { +"Add to library" }
        }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
